import { useCallback, useMemo } from 'react';
import useQueryParams from './useQueryParams';
import {
  DEFAULT_LIMIT,
  LIMIT_PARAM_KEYWORD,
  PAGE_PARAM_KEYWORD,
} from 'data/global';
import { getPageParams } from 'utils';

type Config = {
  defaultLimit?: string;
  limitParam?: string;
  pageParam?: string | string[];
};

export default function useNumberOfResultsPerPage(config?: Config) {
  const {
    defaultLimit = DEFAULT_LIMIT,
    limitParam = LIMIT_PARAM_KEYWORD,
    pageParam = PAGE_PARAM_KEYWORD,
  } = config || {};

  const { params, setMultipleQueryParams } = useQueryParams();

  const limit = useMemo(
    () => params?.[limitParam] || defaultLimit,
    [defaultLimit, limitParam, params],
  );

  const updateLimit = useCallback(
    (limit: string) => {
      const pageParams = getPageParams(pageParam);

      setMultipleQueryParams({
        ...pageParams,
        [limitParam]: limit,
      });
    },
    [limitParam, pageParam, setMultipleQueryParams],
  );

  return {
    limit,
    updateLimit,
  };
}
